module.exports = __webpack_public_path__ + "static/media/alis30.8fc08cfe.jpg";